// extracted by mini-css-extract-plugin
module.exports = {"userMenuIcon":"Header_userMenuIcon__Tdi_a"};